import React from "react";

export default function DeleteIcon({ size = 64, color = "#32363F", strokeWidth = 2.2, ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" width={size} height={size} {...props}>
      <path d="M22 19h20"/>
      <path d="M26 19v-4h12v4"/>
      <path d="M22 19l2 27a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3l2-27"/>
      <path d="M28 26v16M32 26v16M36 26v16"/>
    </svg>
  );
}
